import { ReactElement } from 'react';
import { Stack, DialogContentText, Box, Link } from '@mui/material';

import { useTypePartnerCompany } from '~hooks/useTypePartnerCompany';
import { toAbsoluteUrl } from '~utils/assetsHelpers';

const AssistantGenerateRoutesDialogByTemplateContentFormNotTemplatesInfo =
  (): ReactElement => {
    const { isCarrier } = useTypePartnerCompany();

    return (
      <Stack spacing={2} flex={1}>
        <Stack spacing={2} flex={1} justifyContent="center" alignItems="center">
          <DialogContentText
            fontSize={22}
            fontWeight="bold"
            color="text.secondary"
          >
            No se encontraron plantillas activas
          </DialogContentText>

          <Stack spacing={2} direction="row" justifyContent="center">
            <Box
              component="img"
              src={toAbsoluteUrl('/images/not_templates.png')}
              alt="Empty Search"
              sx={{ width: 600, objectFit: 'contain' }}
            />
          </Stack>
        </Stack>

        <DialogContentText
          variant="caption"
          // @NEW-GIVER-DASHBOARD: Hide until the help URL is available for Givers
          visibility={isCarrier ? 'visible' : 'hidden'}
        >
          Para mayor información sobre plantillas, diríjase a este{' '}
          <Link
            // @ASSITANT-GENERATE_ROUTE: Change link
            href="https://routix.tawk.help/article/asociar-empresas"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
            fontWeight="bold"
          >
            artículo
          </Link>
        </DialogContentText>
      </Stack>
    );
  };

export default AssistantGenerateRoutesDialogByTemplateContentFormNotTemplatesInfo;
